{
    "PartitionList_Column_Description": "Description",
    "PartitionList_Column_IDInTelSys": "ID",
    "PartitionList_Column_Licence": "Licence",
    "PartitionList_Column_Extensions": "Extensions",
    "PartitionList_Column_AcdAgents": "Agents",
    "PartitionList_Column_AppUsers": "Users",
    "PartitionList_Column_SyncType": "Sync Type",
    "PartitionList_Column_Status": "Status",
    "PartitionList_Filter_Licence": "Licence",
    "PartitionList_CountLink_ExtensionsAria": "View devices in this partition",
    "PartitionList_CountLink_AcdAgentsAria": "View ACD agents in this partition",
    "PartitionList_CountLink_AppUsersAria": "View app users in this partition",
    "PartitionList_Add_Disabled_SelectTelephonyServer": "Select a telephony server to add a partition.",
    "PartitionList_LicenceFilter_AkixiLite": "Only Akixi Lite Users",
    "PartitionList_LicenceFilter_Akixi1000": "Akixi 1000 (Including Akixi Presence and Akixi ONE Users)",
    "PartitionList_LicenceFilter_Akixi2000": "Akixi 2000",
    "PartitionList_LicenceFilter_Business": "Akixi Business",
    "PartitionList_Delete_Confirm": "Are you sure you want to delete the following?\n\n**{}**\n\nAll device and ACD agent configuration entries defined against them will also be deleted.",
    "PartitionList_Delete_Confirm_AppUsers": "\n\n{} application user(s) are currently associated with the selected partition(s) and will be automatically deleted.\n\nUncheck the option below to only delete the designated partition(s).",
    "PartitionList_Delete_ReadOnlyRefused": "The following partition(s) are read-only and cannot be deleted: {}",
    "PartitionList_Delete_Failures": "The following partition(s) could not be deleted:\n{}",
    "PartitionList_Delete_Checkbox_AutoDeleteUsers": "Automatically Delete Associated Application Users",
    "PartitionList_Delete_Disabled_ReadOnly": "Read-only partitions cannot be deleted.",
    "NAME": "PartitionListLanguage"
}
